var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './pager.scss';
import classNames from 'classnames';
import { IDENTIFIER_PAGER, IDENTIFIER_PAGER_ACTIONS_NEXT, IDENTIFIER_PAGER_ACTIONS_PREVIOUS, IDENTIFIER_PAGER_PAGE, } from 'src/ui/components/Pager/constants';
// si <= 4 alors on complete jusqua 1 et on a va jusqu'a n + 1 puis '...'
// si >= max - 4 alors on complete jusqua max et on va jusqua n - 1 puis '...'
// sinon on '...' /  n - 1 / n / n + 1 / '...'
var getPageReachable = function (nbOfPages, currentPage) {
    var pagesReachable = [];
    if (nbOfPages <= 8) {
        for (var i = 1; i <= nbOfPages; i++) {
            pagesReachable.push(i);
        }
        return pagesReachable;
    }
    else if (currentPage <= 4) {
        for (var i = 1; i <= currentPage; i++) {
            pagesReachable.push(i);
        }
        return pagesReachable.concat([currentPage + 1, '...', nbOfPages]);
    }
    else if (nbOfPages - currentPage < 4) {
        for (var i = nbOfPages; i >= currentPage; i--) {
            pagesReachable.push(i);
        }
        return pagesReachable.concat([currentPage - 1, '...', 1]).reverse();
    }
    else {
        return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', nbOfPages];
    }
};
// IMPROVEMENT:
// - debounce onChange
export var Pager = function (props) {
    var _a = props.labelPrevious, labelPrevious = _a === void 0 ? 'Previous' : _a, _b = props.labelNext, labelNext = _b === void 0 ? 'Next' : _b, nbOfPages = props.nbOfPages, currentPage = props.currentPage, onChange = props.onChange;
    var pageReachable = getPageReachable(nbOfPages, currentPage);
    var showPrevious = currentPage > 1;
    var showNext = currentPage < nbOfPages;
    var previousClassName = classNames('pagerItem', 'pageReachableButton', {
        buttonHidden: !showPrevious,
    });
    var nextClassName = classNames('pagerItem', 'pageReachableButton', {
        buttonHidden: !showNext,
    });
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_PAGER, className: 'pagerWrapper' }, { children: [_jsx("div", __assign({ "data-test": IDENTIFIER_PAGER_ACTIONS_PREVIOUS, className: previousClassName, onClick: showPrevious ? function () { return onChange(currentPage - 1); } : null }, { children: _jsx("p", { children: labelPrevious }) })), _jsx("div", __assign({ className: 'numericPagesWrapper' }, { children: pageReachable.map(function (item, index) {
                    var isClickable = typeof item === 'number' && !(currentPage === item);
                    var isCurrent = currentPage === item;
                    return (_jsx("div", __assign({ "data-test": IDENTIFIER_PAGER_PAGE, className: classNames('pagerItem', isClickable ? 'pageReachable' : undefined), onClick: isClickable ? function () { return onChange(item); } : null }, { children: _jsx("p", __assign({ className: isCurrent ? 'currentPage' : null }, { children: item })) }), "".concat(item, "-").concat(index)));
                }) })), _jsx("div", __assign({ "data-test": IDENTIFIER_PAGER_ACTIONS_NEXT, className: nextClassName, onClick: showNext ? function () { return onChange(currentPage + 1); } : null }, { children: _jsx("p", { children: labelNext }) }))] })));
};
